<template>
    <CModal class="modal-chooseFile" title="Danh sách sản phẩm" :show.sync="isShowModal" :closeOnBackdrop="false"
      :size="'xl'">
      <div id="chooseProductModal" class="custom-scroll">
        <CCard class="content-fade-in">
          <CCardBody>
            <CRow class="mb-3 search-panel">
              <CCol>
                <div class="form-group">
                  <label style="color: white"></label>
                  <div>
                    <CButton style="float: right; margin-left: 5px" color="primary" v-c-tooltip.hover="'Tải lại'"
                      class="btn-action-primary" @click="loadData()">
                      <i class="fa fa-refresh"></i>&nbsp; Tải lại
                    </CButton>
                  </div>
                </div>
              </CCol>
            </CRow>
  
            <CDataTable class="custom-scroll" :items="mainTable.items" :fields="mainTable.options.fields" :sorter="true"
              :loading="loading.value" :sorterValue="{ column: null, asc: 'true' }"
              :tableFilter="{ label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false }"
              :itemsPerPageSelect="{ label: ' ', values: [10, 15, 20, 50], external: true }" :clickableRows="true"
              :hover="true" @pagination-change="changeItemPerPage" @row-clicked="rowClickTable">
              <template #index="{ index, item }">
                <td class="action-btn-group">
                  <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id"
                    name="locationSelected" :checked="item.isSelected" />
                </td>
              </template>
              <template #action="{ item }">
                <td class="action-btn-group">
                  <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id" name="test"
                    :checked="item.checked" />
                </td>
              </template>
              <template slot="no-items-view">
                <span style="color: #969696">Danh sách trống!</span>
              </template>
              <template slot="loading">
                <BaseFormLoading :loading="true"></BaseFormLoading>
              </template>
            </CDataTable>
  
            <div v-if="pagination && pagination.totalElement !== 0">
              <div style="display:flex; flex-wrap:wrap;">
                <div style="font-size:.95em;color:gray; padding-left:.75rem;">
                  {{ fromElement }}-{{ toElement }} /
                  {{ pagination.totalElement }} bản ghi
                </div>
                <nav style="margin-left:auto;">
                  <CPagination @update:activePage="updateActivePage" :activePage.sync="pagination.activePage"
                    :pages="pagination.pages" :total-rows="pagination.totalRows" :per-page="pagination.pageSize"
                    prev-text="Prev" next-text="Next" hide-goto-end-buttons />
                </nav>
              </div>
            </div>
          </CCardBody>
        </CCard>
  
      </div>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" :disabled="itemChooseSelected == ''" @click="submitSelectedChoose()">
          <i class="fa fa-check"></i> Chọn
        </button>
      </template>
    </CModal>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  import { DatePicker } from "v-calendar";
  
  export default {
    name: "BaseChooseProductModal",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      DatePicker,
      BaseModal
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      return {
        isShowModal: true,
        loading: {
          value: false,
        },
        mainTable: {
          options: {
            fields: [
              { key: "index", label: "#", sorter: false, filter: false },
              { key: "code", label: "Mã sản phẩm" },
              { key: "name", label: "Tên sản phẩm" },
              { key: "cateName", label: "Danh mục sản phẩm" },
            ],
            slots: [
              "index"
            ],
            sorter: true,
            columnFilter: false,
          },
          items: [],
        },
        pagination: {
          activePage: 1,
          pages: 1,
          pageSize: 20,
          totalElement: 0,
          totalRows: 0
        },
        itemChooseSelected: ''
      };
    },
    methods: {
      loadData(isRefresh) {
        let that = this;
        that.loading.value = true;
  
        that.$helper.loadDataSource({
          url: "/product/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.pageSize = that.pagination.pageSize;
            params.pageNumber = that.pagination.activePage - 1;
            return params;
          },
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              if (!isRefresh) {
                that.mainTable.items = [];
              }
              let _data = response.data.data;
              _data.dataContent.content.map((each) => {
                if (that.itemChooseSelected != null && that.itemChooseSelected != ''
                  && that.itemChooseSelected.id && each.id == that.itemChooseSelected.id) {
                  each.isSelected = true;
                } else {
                  each.isSelected = false;
                }
                that.mainTable.items.push(each);
              });
              that.setupPagination(_data);
              that.isShow = true;
            }
            that.loading.value = false;
          },
          errorCallback: function (error) {
            that.loading.value = false;
            that.$helper.handleError(that.$router, error);
          },
        });
      },
      updateActivePage: function (activePage) {
        this.pagination.activePage = activePage;
        this.loadData();
      },
      setupPagination(_dataResponse) {
        this.pagination.pages = Math.ceil(_dataResponse.totalElement / this.pagination.pageSize);
        this.pagination.totalElement = _dataResponse.totalElement;
      },
      rowClickTable(...args) {
        this.mainTable.items.map((item, index) => {
          if (item.id === args[0].id) {
            item.isSelected = true;
            this.itemChooseSelected = item;
          } else {
            item.isSelected = false;
          }
        });
      },
      submitSelectedChoose() {
        if (this.itemChooseSelected == null || this.itemChooseSelected == '') {
          return;
        }
        this.$emit('item:selected', this.itemChooseSelected);
      },
      changeItemPerPage(value) {
        this.pagination.activePage = 1;
        this.pagination.pageSize = value;
        this.loadData();
      },
    },
    created: function () {
    },
    mounted() {
      this.loadData();
    },
    watch: {
      isShowModal: function (value) {
        if (!value) {
          this.$emit("close-modal", false);
        }
      },
    },
    computed: {
      fromElement: function () {
        return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
      },
      toElement: function () {
        return (
          (this.pagination.activePage - 1) * this.pagination.pageSize +
          this.mainTable.items.length
        );
      },
    },
  };
  </script>
  
  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }
  </style>
  <style lang="scss">
  #chooseProductModal {
    .form-check-input {
      width: 16px;
      height: 16px;
    }
  }
  </style>
  